import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Component, Field } from "@contember/binding";
import { SimpleRelativeSingleFieldProxy } from "./SimpleRelativeFieldProxy.js";
const SimpleRelativeSingleField = function(render, displayName, defaultProps) {
  return Component(
    (props) => /* @__PURE__ */ jsx(SimpleRelativeSingleFieldProxy, { ...defaultProps, ...props, render }),
    (props) => {
      const normalizedProps = {
        ...defaultProps,
        ...props
      };
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Field,
          {
            defaultValue: normalizedProps.defaultValue,
            field: normalizedProps.field,
            isNonbearing: normalizedProps.isNonbearing
          }
        ),
        normalizedProps.label,
        normalizedProps.labelDescription,
        normalizedProps.description
      ] });
    },
    displayName
  );
};
export {
  SimpleRelativeSingleField
};
//# sourceMappingURL=SimpleRelativeSingleField.js.map
